<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование информации о пользователе') }}
        </v-toolbar-title>
      </v-toolbar>
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-3">
        <ValidationObserver ref="profile" @keydown.native.enter="focusOnBtn('continueBtn')">
          <validatable-text-input
              v-model="profile.contactPerson"
              v-test="{ input: 'contactPerson' }"
              rules="required"
              :label="$t('Доверенное лицо')"
              prepend-icon="person" />
          <validatable-document-person-identity
              v-model="profile.documentPersonIdentity"
              v-test="{ input: 'documentPersonIdentity' }"
              :rules="{ required: true,
                        regex: /^\d{4}\s{1}\d{6}$/ }"
              prepend-icon="assignment_ind" />
          <validatable-text-input
              v-model="profile.phone"
              v-test="{ input: 'phone' }"
              :rules="{ required: true,
                        max: 30,
                        regex: /^[+]?[\d\s(\-);,]+$/ }"
              :label="$t('Телефон')"
              prepend-icon="settings_phone" />
          <validatable-text-input
              v-model="profile.email"
              v-test="{ input: 'email' }"
              rules="required|email"
              :label="$t('Email пользователя')"
              prepend-icon="alternate_email" />
        </ValidationObserver>
      </v-card-text>
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDocumentPersonIdentity from '@/components/reused/ui/ValidatableDocumentPersonIdentity.vue'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      ValidatableDocumentPersonIdentity,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            userId: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        profile: {
          contactPerson: null,
          documentPersonIdentity: null,
          phone: null,
          email: null
        }
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        user: state => (state[USER_MANAGEMENT.STATE.CURRENT_USER] || {})
      })
    },
    watch: {
      user: {
        handler (newVal) {
          this.profile.contactPerson = newVal.contactPerson
          this.profile.phone = newVal.phone
          this.profile.email = newVal.email
          this.profile.documentPersonIdentity = newVal.documentPersonIdentity
        }
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.dialogProp.userId) {
          return
        }
        vm.getUserForAdmin()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserForAdminAction: USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN,
        updateUserAction: USER_MANAGEMENT.ACTIONS.UPDATE_USER,
        clearUserForAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserForAdminAction()
          ])
      },
      getUserForAdmin: async function () {
        this.isLoading = true
        try {
          await this.getUserForAdminAction({
            userId: this.dialogProp.userId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      continueOperation: async function () {
        try {
          const result = await this.$refs.profile.validate()
          if (!result) {
            return
          }
          this.isLoading = true
          await this.updateUserAction({
            profile: this.profile,
            userId: this.dialogProp.userId
          })
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.isLoading = false
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
          // проверка или сохранение формы неуспешно, остаемся в диалоговом окне
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
